import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import {
	SaveInsurerCompanyByValuator,
	SaveValuatorRequest,
	ValuatorFilterRequest,
	ValuatorDataRequest,
	DeleteValuatorInsurerRequest,
} from "@/main/models/request/valuatorRequest";
import { AxiosResponse } from "axios";
import { IValuatorApi } from "../base/registration/valuatorApi";
import { api } from "../base/api";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { InsurerByValuatorResponse, ValuatorDataResponse, ValuatorSearchGridResponse } from "@/main/models/response";

const baseRoute: string = "Valuator";

export class ValuatorApi extends IValuatorApi {
	getValuatorsDomain(request: ValuatorFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}

	getValuatorsGrid(
		request: ValuatorFilterRequest,
	): Promise<AxiosResponse<PaginationResponse<ValuatorSearchGridResponse>>> {
		return api.get(`${baseRoute}`, { params: request });
	}

	getValuatorData(request: ValuatorDataRequest): Promise<AxiosResponse<Result<ValuatorDataResponse>>> {
		return api.get(`${baseRoute}/getvaluatordata`, { params: request });
	}

	getAllInsurerByValuator(
		guidValuator: string,
		guidInsurerCompany: string,
	): Promise<AxiosResponse<Result<InsurerByValuatorResponse[]>>> {
		return api.get(`Valuator_Insurer/getallinsurerbyvaluator`, {
			params: { guidValuator, guidInsurerCompany },
		});
	}

	save(request: SaveValuatorRequest): Promise<AxiosResponse<Result<ValuatorDataResponse>>> {
		return api.post(`${baseRoute}/save`, request);
	}

	saveInsurerCompanyByValuator(
		request: SaveInsurerCompanyByValuator,
	): Promise<AxiosResponse<Result<InsurerByValuatorResponse[]>>> {
		return api.post(`Valuator_Insurer/saveinsurerbyvaluator`, request);
	}

	inactiveInsurerByValuator(request: DeleteValuatorInsurerRequest): Promise<AxiosResponse> {
		return api.post(`Valuator_Insurer/inactivateinsurerbyvaluator`, request);
	}
}
